const common = {
  isEmail(mail) {
    if (
      new RegExp(
        /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
      ).test(mail)
    ) {
      return true;
    } else {
      return false;
    }
  },
  isAllNumeric(value) {
    return new RegExp(/^-?\d+(\.\d{1,64})?$/).test(value);
  },
  isNumeric(value) {
    return new RegExp(/^-?\d+$/).test(value);
  },
  isFloat(value) {
    return new RegExp(/^\d+(\.\d{1,64})?$/).test(value);
  },
  isPattern(pattern, str) {
    if (new RegExp(pattern).test(str)) {
      return true;
    } else {
      return false;
    }
  },
  onlyNumbers(str) {
    return str.replace(/[^0-9]+/gi, "");
  },
  onlyFloat(str) {
    return str.replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, "$1");
  },
  objectLevel(obj, level) {
    level = level.split(".");
    let data = obj;
    if (data === null) {
      data = "";
    } else {
      for (var i = 0; i < level.length; i++) {
        if (typeof data !== "object") {
          data = "";
        } else {
          data = data[level[i]];
        }
      }
    }
    return data;
  },
  // initialize
  initFields(formData) {
    let data = {};
    for (const [key, field] of Object.entries(formData)) {
      data[key] = typeof field.value == "undefined" ? "" : field.value;
    }
    return data;
  },
  initErrors(formData) {
    let data = {};
    for (const [key, field] of Object.entries(formData)) {
      if (field.validate) {
        data[key] = "";
      }
    }
    return data;
  },
  initAllow(formData) {
    let data = {};
    for (const [key, field] of Object.entries(formData)) {
      data[key] = "*";
      if (field.allow) {
        data[key] = field.allow;
      }
    }
    return data;
  },
  // validate
  amlMessage(str) {
    return str.replace("${amlHash}", "#");
  },
  hashMessage(str, rep) {
    str = str.replace("#value#", rep);
    str = str.replace("+number", "positive number");
    str = str.replace("+-number", "positive or negative number");
    str = str.replace("+float", "positive float");
    return str;
  },

  initValidate(formData) {
    let t1 = ["req", "notNull", "email"];
    let t2 = [
      "min",
      "max",
      "sameAs",
      "sameAsField",
      "type",
      "et",
      "net",
      "lt",
      "lte",
      "gt",
      "gte",
      "bool",
    ];
    let t3 = ["regExp"];
    let t4 = ["objReq", "arrReq", "objValReq"];
    let message = {
      req: "The field cannot be empty.",
      notNull: "The field cannot be null.",
      objValReq: "The field cannot be empty.",
      email: "Please enter a valid email address.",
      sameAs: "The value is not same as #value#.",
      sameAsField: "The value is not same as #value#.",
      min: "Minimum length should be #value#.",
      max: "Maximum length should be #value#.",
      et: "The value must equal to #value#.",
      net: "The value must not equal to #value#.",
      lt: "The value is must less than #value#.",
      lte: "The value is not less than or equal to #value#.",
      gt: "The value is must greater than #value#.",
      gte: "The value is not greater than or equal to #value#.",
      type: "Enter a valid #value#.",
      regExp: "A valid value is required.",
      bool: "The value must be boolean",
    };
    let data = {};
    for (const [key, field] of Object.entries(formData)) {
      if (field.validate) {
        data[key] = {};
        field.validate.map((item) => {
          let a = item.split("#");
          let b = a[0].split(":");
          if (t1.includes(a[0])) {
            data[key][a[0]] = this.amlMessage(a[1] || message[a[0]]);
          } else if (t2.includes(b[0])) {
            data[key][b[0]] = {
              message: this.amlMessage(
                a[1] || this.hashMessage(message[b[0]], b[1])
              ),
              value: b[1] || "",
            };
          } else if (t3.includes(a[0])) {
            data[key][a[0]] = {
              message: this.amlMessage(a[1] || message[a[0]]),
              pattern: field.pattern,
            };
          } else if (t4.includes(a[0])) {
            data[key][a[0]] = {
              message: this.amlMessage(a[1] || message[a[0]]),
              obj: field.obj,
            };
          }
        });
      }
    }
    return data;
  },
};
export default common;
